import { login, sendOtp, verifyOtp, logout } from '@/api/login'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { updateNotifications, getSettings, updateSettings,updateSettingsByField, getSmsEmailConfig, updateSmsEmailConfig, getEventSmsEmailConfig, updateEventSmsEmailConfig, smsEmailEventSetting, customNotification, getDesignConfig, updateDesignConfig, getAssets, changePassword } from '@/api/settings'

import Cookies from 'js-cookie'

const auth = {
  state: {
		isSocketConnected: true,
    ip_addr: null,
    currentUser: (Cookies.get('currentUser')) ? JSON.parse(Cookies.get('currentUser')) : {},
    token: getToken(),
    name: '',
    avatar: '',
    roles: (Cookies.get('roles')) ? Cookies.get('roles') : {},
    useractivechannel: null
  },

  mutations: {
    SET_USER_IP_ADDR: (state) => {
      fetch("https://api.ipify.org?format=json")
      .then(x => x.json())
      .then(({ip}) => {
        state.ip_addr = ip;
      });
    },
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
      Cookies.set('roles', roles)
    },
    SET_USER: (state, user) => {
      state.currentUser = user
      Cookies.set('currentUser', user)
    },
    SET_CONFIRMATION_VOTE: (state, confirmation_vote) => {
      state.confirmation_vote = confirmation_vote
    },
    SET_USER_ACTIVE_CHANNEL: (state,login = true) => {
      // Added Token for privatisation
      window.Echo.connector.options.auth.headers.Authorization = login ? "Bearer " + state.token : null;
      
      if(login) {
        if(state.roles == 'user')
          state.useractivechannel = window.Echo.join('useractive');
      }
      else {
        if(state.useractivechannel !== null) { 
          state.useractivechannel = null;
          window.Echo.leave('useractive');
        }
      }
    },
		SET_IS_SOCKET_CONNECTED: (state, isConnected) => {
			state.isSocketConnected = isConnected;
		}
  },

  actions: {
    /**
     * Login API
     * @param commit
     * @param userInfo
     * @returns {Promise<any>}
     * @constructor
     */
    Login({ commit }, userInfo) {
      const email = userInfo.email.trim()
      const password = userInfo.password 
      return new Promise((resolve, reject) => {
        login(email, password).then(response => {
          const data = response.data
          commit('SET_TOKEN', data.token)
          if(data.data) {
            commit('SET_USER', data.data)
            commit('SET_ROLES', data.data.user_role)
          }
          setToken(data.token)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    
    /**
     * Logout
     * @param commit
     * @param state
     * @returns {Promise<any>}
     * @constructor
     */
    async Logout({ commit }) {
      const res = await logout();
      commit('SET_TOKEN', '')
      Cookies.remove('roles')
      Cookies.remove('currentUser')
      removeToken()
      commit('SET_USER_ACTIVE_CHANNEL',false);
    },
    /**
     * Send OTP API
     * @param commit
     * @param userInfo
     * @returns {Promise<any>}
     * @constructor
     */
    SendOtp({ commit },userInfo) {
      const id_number = userInfo.id_number
      return new Promise((resolve, reject) => {
        sendOtp(id_number).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    /**
     * Verify OTP API
     * @param commit
     * @param userInfo
     * @returns {Promise<any>}
     * @constructor
     */
    VerifyOtp({commit},userInfo) {
      const id_number = userInfo.id_number
      const otp = userInfo.otp
      return new Promise((resolve, reject) => {
        verifyOtp(id_number,otp).then(response => {
          const data = response.data
          commit('SET_TOKEN', data.token)
          commit('SET_USER', data.data)
          commit('SET_ROLES', data.data.user_role)
          setToken(data.token)
          commit('SET_USER_ACTIVE_CHANNEL')
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    GetSettings({commit}){
      return new Promise((resolve, reject) => {
        getSettings().then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    UpdateSettings({commit},settingsForm){
      return new Promise((resolve, reject) => {
        updateSettings(settingsForm).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    UpdateSettingsByField({commit},settingsForm){
      return new Promise((resolve, reject) => {
        updateSettingsByField(settingsForm).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    GetSmsEmailConfig({commit}){
      return new Promise((resolve, reject) => {
        getSmsEmailConfig().then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    UpdateSmsEmailConfig({commit}, configData){
      return new Promise((resolve, reject) => {
        updateSmsEmailConfig(configData).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    GetEventSmsEmailConfig({commit}, configData){
      return new Promise((resolve, reject) => {
        getEventSmsEmailConfig(configData).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    UpdateEventSmsEmailConfig({commit}, configData){
      return new Promise((resolve, reject) => {
        updateEventSmsEmailConfig(configData).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    UpdateNotifications({commit}, configData){
      return new Promise((resolve, reject) => {
        updateNotifications(configData).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    SmsEmailEventSetting({ commit }, data) {
      return new Promise((resolve, reject) => {
        smsEmailEventSetting(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    CustomNotification({commit}, data){
      return new Promise((resolve, reject) => {
        customNotification(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    GetDesignConfig({commit}, data){ 
      return new Promise((resolve, reject) => {
        getDesignConfig(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    UpdateDesignConfig({commit}, data){ 
      return new Promise((resolve, reject) => {
        updateDesignConfig(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    GetAssets({commit}, data){ 
      return new Promise((resolve, reject) => {
        getAssets(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    ChangePassword({commit}, data){ 
      return new Promise((resolve, reject) => {
        changePassword(data).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

  },

  getters: {
    ipAddress: (state) => state.ip_addr
  }
}

export default auth
